import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { i18nState } from 'redux-i18n'

const talkativeApp = combineReducers({
  i18nState,
  router: routerReducer
})

export default talkativeApp



// WEBPACK FOOTER //
// ./src/reducers/index.js